import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import MessagingService from 'services/MessagingService/MessagingService';
import {
  TWITTER_ACCOUNT_INFO_ERROR,
  TWITTER_ACCOUNT_INFO_RESPONSE,
  TWITTER_TWEET_ERROR,
  TWITTER_TWEET_RESPONSE,
} from 'services/MessagingService/EventNames';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
const TWITTER_AUTH_API_URL = `${BASE_URL}/rest/v1.0/twitter`;
const TWITTER_API_URL = `${BASE_URL}/rest/v1.0/socialNetwork/{username}/twitter`;

export const TWITTER_BEGIN_AUTH_URL = `${TWITTER_AUTH_API_URL}/begin-login`;

class TwitterService {
  constructor() {
    this.messagingService = new MessagingService();
  }

  getAccountInfo = (username) => {
    const rawUrl = ApiService.substitute(TWITTER_API_URL, { username });
    const encodedUrl = encodeURI(rawUrl);

    return ApiService.get(encodedUrl)
      .then((response) => this.messagingService.emit(TWITTER_ACCOUNT_INFO_RESPONSE, response))
      .catch((error) => this.messagingService.emit(TWITTER_ACCOUNT_INFO_ERROR, error));
  };

  sendTweet = (message, attachment, username) => {
    const rawUrl = ApiService.substitute(TWITTER_API_URL, { username });
    const encodedUrl = encodeURI(rawUrl);
    const formData = new FormData();
    if (attachment) {
      formData.append('attachment', attachment);
    }
    formData.append('message', message);

    return ApiService.post(encodedUrl, {
      data: formData,
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then((response) => this.messagingService.emit(TWITTER_TWEET_RESPONSE, response))
      .catch((error) => this.messagingService.emit(TWITTER_TWEET_ERROR, error));
  };
}

export default new TwitterService();
